import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";


export default function Seo_Texas() {
  return (
    <div className="Seo pt-[160px] sm:pt-0">
      <Helmet>
        <title> SEO Services in Texas That Grow Traffic & Leads | Mean3</title>
        <meta
        name="description"
        content="Looking for a trusted SEO company in Texas? Mean3 delivers expert SEO services that improve rankings, attract qualified leads, and help your business grow with proven search strategies."
        />
      </Helmet>
      <Section1 />
      <Section4 />
     
      <Section6 />
      <Section7 />
      <Section8 />
      <Section5 />
      <Section10 />
      <Section11 />
      <Section9 />
      {/* <Section2 /> */}
      
      <Section3 />

    </div>
  );
}
